import { render } from "./ModalQR.vue?vue&type=template&id=062da434"
import script from "./ModalQR.vue?vue&type=script&lang=js"
export * from "./ModalQR.vue?vue&type=script&lang=js"

import "./ModalQR.vue?vue&type=style&index=0&id=062da434&lang=css"
script.render = render

export default script